export enum TipoAtendimentoEnum {
  MESA = 'MESA',
  DELIVERY = 'DELIVERY',
  BALCAO = 'BALCAO'
}
